export default "__VITE_ASSET__vonUwGWU__"